// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"HomeIcon_iconWrapper__S49J8"};